const _excluded = ["invert", "invertSmallHeader", "hiddenNav"],
  _excluded2 = ["component", "hiddenLink", "invert"],
  _excluded3 = ["variation", "config", "showMenu", "logoLink", "enableSearch", "hidePhoneNumber", "isCorporate", "invert", "withAbsoluteLinks", "absoluteBaseUrl"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React, { useState, useContext } from "react";
import styled, { ThemeContext, css } from "styled-components";
import { p } from "@nib/layout";
import { ModeProvider, standardFocusStyleDeclarations, focusOutlineOffset, colorBrandBase, colorBrandLight, colorLightest, colorWhite, colorDarkest, token } from "@nib-components/theme";
import { MenuSystemIcon, SearchSystemIcon, PhoneSystemIcon } from "@nib/icons";
import Link from "@nib-components/link";
import Logo from "@nib-components/logo";
import Drawer from "@nib/drawer";
import { SEARCH_URL } from "../shared";
import variantConfig from "../config"; // eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SmallHeaderWrapper = styled(_ref => {
  let {
      invert,
      invertSmallHeader,
      hiddenNav
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("header", rest);
})`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${_ref2 => {
  let {
    hiddenNav
  } = _ref2;
  return hiddenNav ? `center` : `space-between`;
}};

  ${_ref3 => {
  let {
    invert
  } = _ref3;
  return invert ? css`
          background-color: var(--smallHeaderColorBgInvert, ${colorBrandBase});
        ` : css`
          background-color: var(--smallHeaderColorBg, ${colorWhite});
          border-block-end: 1px solid var(--smallHeaderColorBorderDivider, ${colorLightest});
        `;
}}
`;
export const LogoLink = styled(Link).attrs({
  underline: false
})`
  display: flex;
  align-items: center;

  && {
    ${p(4)};
  }

  &:focus-visible {
    ${standardFocusStyleDeclarations};
    outline-offset: -${focusOutlineOffset};
  }
`;
const HeaderLinks = styled.nav`
  display: flex;
  flex-wrap: wrap;
`; // eslint-disable-next-line jsx-a11y/anchor-has-content, @typescript-eslint/no-unused-vars
const HeaderLink = styled(_ref4 => {
  let {
      component: Component,
      hiddenLink,
      invert
    } = _ref4,
    rest = _objectWithoutProperties(_ref4, _excluded2);
  return Component ? /*#__PURE__*/React.createElement(Component, rest) : /*#__PURE__*/React.createElement("a", rest);
}).attrs({
  "data-testid": "header-link"
})`
  display: ${_ref5 => {
  let {
    hiddenLink
  } = _ref5;
  return hiddenLink ? `none` : `flex`;
}};
  flex-direction: row;
  align-items: center;
  ${p(4)};
  border: none;
  border-inline-start-width: 1px;
  border-inline-start-style: solid;
  background: transparent;

  ${_ref6 => {
  let {
    theme,
    invert
  } = _ref6;
  return invert ? css`
          border-inline-start-color: ${token("smallHeader.color.border.divider.invert", theme.id === "nib" ? "#436e60" : "hsla(0, 0%, 0%, 0.2)")};
          color: ${token("smallHeader.color.fg.icons.invert", theme.id === "nib" ? colorBrandLight : colorWhite)};
        ` : css`
          border-inline-start-color: var(--smallHeaderColorBorderDivider, ${colorLightest});
          color: var(--smallHeaderColorFgIcons, ${colorBrandBase});
        `;
}}

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    ${standardFocusStyleDeclarations};
    outline-offset: -${focusOutlineOffset};
    z-index: 1;
  }
`;
HeaderLink.displayName = "HeaderLink";
const MenuLink = styled(HeaderLink).attrs({
  "data-testid": "menu-link"
})`
  ${_ref7 => {
  let {
    invert
  } = _ref7;
  return invert ? css`
          color: var(--smallHeaderColorFgMenuInvert, ${colorWhite});
        ` : css`
          color: var(--smallHeaderColorFgMenu, ${colorDarkest});
        `;
}}
`;
MenuLink.displayName = "MenuLink";
export const SmallHeader = props => {
  const {
      variation = "arhi",
      config,
      showMenu = false,
      logoLink,
      enableSearch = false,
      hidePhoneNumber = false,
      isCorporate = false,
      invert = false,
      withAbsoluteLinks = false,
      absoluteBaseUrl
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded3);
  const dataSource = config ? config : variantConfig[variation]({
    withAbsoluteLinks,
    absoluteBaseUrl
  });
  const smallHeaderData = dataSource.smallHeaderConfig;
  const drawerLinks = dataSource.navLinks;
  const ribbonLinks = dataSource.ribbon;
  const drawerChildren = dataSource.drawerChildren;
  const customLogoLabel = dataSource.logoLabel;
  const logoHref = logoLink ? logoLink : smallHeaderData && smallHeaderData.logoUrl ? smallHeaderData.logoUrl : "/";
  const CustomLogo = dataSource === null || dataSource === void 0 ? void 0 : dataSource.logoComponent;
  const themeContext = useContext(ThemeContext);
  const logoLabel = `${themeContext.id} Logo`;
  const phoneNumberDefined = Boolean(smallHeaderData.phoneNumber);
  const defaultOrCorporatePhoneNumber = isCorporate && smallHeaderData.corporatePhoneNumber ? smallHeaderData.corporatePhoneNumber : smallHeaderData.phoneNumber;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  return /*#__PURE__*/React.createElement(ModeProvider, {
    mode: "default"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, showMenu && drawerLinks && /*#__PURE__*/React.createElement(Drawer, {
    navLinks: drawerLinks,
    ribbonLinks: ribbonLinks,
    isOpen: isDrawerOpen,
    setIsOpen: setIsDrawerOpen,
    hideQuoteButton: dataSource.hideQuoteButton,
    quoteButtonUrl: dataSource.quoteButtonUrl ? dataSource.quoteButtonUrl : undefined
  }, drawerChildren), /*#__PURE__*/React.createElement(SmallHeaderWrapper, _extends({
    "data-mesh-component": "SMALL-HEADER",
    id: smallHeaderData ? smallHeaderData.id : `small-header`,
    hiddenNav: !showMenu,
    invert: invert
  }, otherProps), /*#__PURE__*/React.createElement(LogoLink, {
    href: logoHref,
    id: "ga-inlink-logo-homepage-mobile",
    "aria-label": customLogoLabel ? customLogoLabel : logoLabel
  }, CustomLogo ? /*#__PURE__*/React.createElement(CustomLogo, {
    size: "small",
    invert: invert
  }) : /*#__PURE__*/React.createElement(Logo, {
    size: "small",
    invert: invert
  })), showMenu && /*#__PURE__*/React.createElement(HeaderLinks, {
    "aria-label": "Main mobile navigation"
  }, enableSearch && /*#__PURE__*/React.createElement(HeaderLink, {
    id: "ga-nav-search-mobile",
    href: SEARCH_URL,
    "aria-label": "Search",
    invert: invert
  }, /*#__PURE__*/React.createElement(SearchSystemIcon, {
    fill: "currentColor"
  })), phoneNumberDefined && !hidePhoneNumber && /*#__PURE__*/React.createElement(HeaderLink, {
    component: "a",
    id: `ga-nav-${variation !== "arhi" ? `${variation}-` : ""}call-mobile`,
    href: `tel:${defaultOrCorporatePhoneNumber && defaultOrCorporatePhoneNumber.replace(/\s+/g, "")}`,
    "aria-label": "Call",
    invert: invert
  }, /*#__PURE__*/React.createElement(PhoneSystemIcon, {
    fill: "currentColor"
  })), smallHeaderData.navLinks && smallHeaderData.navLinks.map(link => {
    const Icon = link.icon;
    return /*#__PURE__*/React.createElement(HeaderLink, {
      component: "a",
      id: `${link.id}-mobile`,
      href: link.url,
      target: link.targetBlank && "_blank",
      rel: link.targetBlank && "noopener noreferrer",
      "aria-label": link.label,
      key: `${link.id}-mobile`,
      invert: invert
    }, /*#__PURE__*/React.createElement(Icon, {
      fill: "currentColor"
    }));
  }), /*#__PURE__*/React.createElement(MenuLink, {
    component: "button",
    id: "ga-nav-menu-mobile",
    onClick: () => {
      setIsDrawerOpen(true);
    },
    "aria-label": "Open menu",
    invert: invert
  }, /*#__PURE__*/React.createElement(MenuSystemIcon, null))))));
};
SmallHeader.displayName = "SmallHeader";
SmallHeader.SmallHeaderWrapper = SmallHeaderWrapper;
SmallHeader.LogoLink = LogoLink;
SmallHeader.HeaderLinks = HeaderLinks;
SmallHeader.HeaderLink = HeaderLink;